import script from "./PriceListUpdated.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceListUpdated.vue?vue&type=script&setup=true&lang=ts"

import "./PriceListUpdated.vue?vue&type=style&index=0&id=9dcdd224&lang=scss"

const __exports__ = script;

export default __exports__